import React, { useEffect, useRef, useState } from 'react'
import styled, { keyframes } from 'styled-components'
// import logo from '../media/ml-logo2.png'
import logo from '../media/MarketLab_logo_.png'
import img1 from '../media/lp1.jpeg'
import img2 from '../media/kr1.jpeg'
import img3 from '../media/bm1.jpeg'
import img4 from '../media/st_3.jpeg'
import img5 from '../media/lp5.jpeg'
import mLogo from '../media/ml-logo-2.png'
import mhero from '../media/m-hero.png'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import SegmentIcon from '@mui/icons-material/Segment';
import FAQ from './FAQ'
import Footer from './Footer'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';



function Root({ sWidth, auth }) {
    const [showNav, setShowNav] = useState(false)

    const showNavRef = useRef(null);

useEffect(() => {
    const handleClickOutside = (event) => {
        if (showNavRef.current && !showNavRef.current.contains(event.target)) {
            setShowNav(false); 
        }
    };


    document.addEventListener('mousedown', handleClickOutside);

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


useEffect(() => {
    if (auth) {
      document.body.style.overflowY = 'scroll';
    } else {
      document.body.style.overflowY = 'hidden';
    }

    return () => {
      document.body.style.overflowY = 'hidden';
    };
  }, [auth]);


  return (
    <>
    {!auth && <>
        {sWidth > 768 ? <Container>

        <Header>
            <div style={{position: 'relative'}}>
                <div className='light' />
                <div className='light_0' />
                <Ray ty={'50'} tr={'5'} w={'700'} h={'25'} d={'8'} c={'#f06'}/>
                <Ray ty={'50'} tr={'10'} w={'400'} h={'15'} d={'6'} c={'#4a90e2'}/>
                <Ray ty={'50'} tr={'20'} w={'360'} d={'25'} c={'#4a90e2'}/>
                <Ray ty={'60'} tr={'25'} w={'500'} h={'25'} d={'8'} c={'#f06'}/>
                <Ray ty={'70'} tr={'35'} w={'600'} h={'15'} d={'6'} c={'#4a90e2'}/>
                <Ray ty={'80'} tr={'40'} w={'360'} d={'25'}/>
                <Ray ty={'90'} tr={'37'} w={'500'} h={'25'} d={'8'} c={'#4a90e2'}/>
                <Ray ty={'100'} tr={'30'} w={'400'} h={'15'} d={'6'} c={'#f06'}/>
                <Ray ty={'50'} tr={'35'} w={'360'} d={'25'} c={'#4a90e2'}/>
                <Ray ty={'110'} tr={'35'} w={'400'} h={'15'} d={'6'} c={'#4a90e2'}/>
                <Ray ty={'120'} tr={'40'} w={'360'} d={'25'} c={'#4a90e2'}/>
                <Ray ty={'125'} tr={'45'} w={'500'} h={'25'} d={'8'} c={'#f06'}/>
                <Ray ty={'130'} tr={'30'} w={'400'} h={'15'} d={'6'} c={'#4a90e2'}/>
                <Ray ty={'135'} tr={'35'} w={'660'} d={'25'} c={'#4a90e2'}/>
                <Ray ty={'150'} tr={'35'} w={'400'} h={'15'} d={'6'} c={'#f06'}/>
                <Ray ty={'140'} tr={'40'} w={'360'} d={'25'} c={'#4a90e2'}/>
                <Ray ty={'130'} tr={'45'} w={'500'} h={'25'} d={'8'} c={'#4a90e2'}/>
                <Ray ty={'100'} tr={'30'} w={'680'} h={'15'} d={'6'} c={'#f06'}/>
                <Ray ty={'150'} tr={'35'} w={'360'} d={'25'} c={'#4a90e2'}/>
                <img src={logo} alt='logo' />
            </div>
            <div style={{marginLeft: 'auto'}}>
                <p onClick={()=> window.open('https://improwth.com/products/market-lab/docs', '_blank')}>Docs</p>
                <p onClick={()=> window.location.href = '#features'}>Features</p>
                <p onClick={()=> window.location.href = '#pricing'}>Pricing</p>
                <p onClick={()=> window.location.href = '/login'}>Sign In</p>
                <p onClick={()=> window.location.href = '/register'}>Create Account</p>
            </div>
        </Header>

        <Hero>
            <div style={{width: '500px'}}>
            <h1>All-in-One Platform for <span>Superior SEO Insights</span> and Competitive Edge</h1>
            <p>Discover MarketLab, the ultimate suite of integrated tools designed to elevate your SEO and digital marketing efforts</p>
            <div>
                <button onClick={()=> window.location.href = '/register'}>Try Now For Free</button>
                <button onClick={()=> window.location.href = '#features'}>Learn More</button>
            </div>
            </div>

            <div style={{position: 'relative'}}>
                <img src={img1} alt='tool images' />
            </div>
        </Hero>

        <InApp id='features'>
            <div className='title'>
                <h2>Discover What’s Inside <span>MarketLab</span></h2>
                <p>Unlock the full potential of your digital marketing strategy with MarketLab's suite of innovative tools</p>
            </div>

            <div className='tools'>
                    <div>
                        <h3>Keyword Research Mastery</h3>
                        <p>Uncover high-impact keywords and tailor your content to target audiences effectively</p>
                        <p className='points'><CheckCircleIcon /> Identify High-Impact Keywords</p>
                        <p className='points'><CheckCircleIcon /> Optimize Content Strategy</p>
                        <p className='points'><CheckCircleIcon /> Discover Niche Opportunities</p>
                    </div>

                    <div>
                        <img src={img2} alt='Keyword Research Tool' />
                    </div>
                </div>


            <div className='tools'>
                    <div>
                        <img src={img3} alt='Keyword Research Tool' style={{width: '790px'}}/>
                    </div>
                    <div>
                        <h3>Link Power Unleashed</h3>
                        <p>Uncover and leverage your website’s backlinks to boost authority and visibility</p>
                        <p className='points'><CheckCircleIcon /> Evaluate Link Quality</p>
                        <p className='points'><CheckCircleIcon /> Identify Toxic Links</p>
                        <p className='points'><CheckCircleIcon /> Monitor Link Growth</p>
                    </div>
                </div>

                <div className='tools'>
                    <div>
                        <h3>Comprehensive Site Testing</h3>
                        <p>Ensure peak performance with extensive tests for speed, functionality, and user experience to keep your site running smoothly and efficiently</p>
                        <p className='points'><CheckCircleIcon /> Page Speed Test</p>
                        <p className='points'><CheckCircleIcon /> Mobile Responsiveness Test</p>
                        <p className='points'><CheckCircleIcon /> Crawlability Test</p>
                    </div>

                    <div>
                        <img src={img4} alt='Keyword Research Tool' />
                    </div>
                </div>

                <div className='tools'>
                    <div>
                        <img src={img5} alt='On-Page Optimization Tool' style={{width: '790px'}} />
                    </div>
                    <div>
                        <h3>On-Page Optimization Tools</h3>
                        <p>Enhance your website’s on-page SEO to improve rankings and user experience with precise optimizations.</p>
                        <p className='points'><CheckCircleIcon /> Optimize Meta Tags and Descriptions</p>
                        <p className='points'><CheckCircleIcon /> Analyze and Adjust Keyword Density</p>
                        <p className='points'><CheckCircleIcon /> Conduct Comprehensive Link Analysis</p>
                    </div>
                </div>


                <div className='title'>
                    <h2>... and more!</h2>
                </div>
        </InApp>

        <MLUpdates>
            <h2>Introducing MarketLab Version 5: The Next Evolution in SEO & Digital Marketing Tools</h2>
            <p>MarketLab Version 5 brings a new level of efficiency and precision to your digital marketing strategy. With enhanced features, improved user experience, and cutting-edge tools, this update empowers you to dive deeper into competitor insights, optimize your site’s performance, and track keyword trends like never before. Whether you're an SEO expert or a business owner, MarketLab v5 provides the ultimate toolkit to stay ahead in an ever-changing digital landscape</p>

            <video controls width="700px">
            <source src='https://firebasestorage.googleapis.com/v0/b/market-lab-2ed93.appspot.com/o/media%2Fml_v5.mp4?alt=media&token=aa7e66d2-6485-47ba-bc26-013553e2b090' type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </MLUpdates>

        <div style={{marginTop: '300px'}} id='pricing'>
        <h2 style={{color: 'white', width: '95%', textAlign: 'center', fontSize: '50px', marginBlock: '20px'}}>Find a plan that's right for you</h2>
        <p style={{fontFamily: 'Quicksand', margin: '10px 0 65px 0', color: 'lightgrey', width: '95%', textAlign: 'center'}}>Choose the perfect plan tailored to your needs and usage preferences</p>
        <Pricing>
            <Card>
                <h3>Forever Free</h3>
                <h4><span className='sign'>$</span><span className='price'>0</span>/month</h4>
                <p>Get 60 credits per month at no cost to explore MarketLab’s essential tools and features</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>

                <p><CheckIcon /> 60 Credits Per Month</p>
                <p><CheckIcon /> No Cost</p>
                <p><CheckIcon /> Ideal for Small Projects</p>
                <p><CheckIcon /> Experience Core Features</p>
                <p><CheckIcon /> Risk-Free Trial</p>
                <p><CheckIcon /> No credit card required</p>
            </Card>

            <Card style={{backgroundColor: 'rgb(32, 41, 56)'}}>
                <h3>Premium</h3>
                <h4><span className='sign'>$</span><span className='price'>20</span>/month</h4>
                <p>Unlock unlimited access, advanced features, and priority support for optimal performance and insights</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>
                <p><CheckIcon /> Unlimited Access</p>
                <p><CheckIcon /> Advanced Insights</p>
                <p><CheckIcon /> Priority Support</p>
                <p><CheckIcon /> Unlimited Projects</p>
                <p><CheckIcon /> Exclusive Features</p>
                <p><CheckIcon /> Fresh Data</p>
            </Card>

            <Card>
                <h3>Occasional Users</h3>
                <p>Buy credits in any amount you need, allowing for flexible, on-demand access to MarketLab features. Ideal for occasional users who want to manage their spending and only pay for what they use</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>

                <p><CheckIcon /> Flexible Credit Purchase</p>
                <p><CheckIcon /> Customizable Plans</p>
                <p><CheckIcon /> Immediate Usage</p>
                <p><CheckIcon /> On-Demand Support</p>
                <p><CheckIcon /> No Subscription Required</p>
                <p><CheckIcon /> Scalable Access</p>
            </Card>
        </Pricing>
        </div>

        <FAQ id='faq'/>


        <Res style={{backgroundColor: 'black', paddingBlock: '100px', width: '100%'}}>
            <h2>Resources to help you get the most out of <span style={{fontFamily: 'Crimson Text', fontWeight: '300'}}>MarketLab</span></h2>

            <div>
                <h3 style={{display: 'flex', alignItems: 'center', gap: '5px'}} onClick={()=> window.open('https://improwth.com/products/market-lab/docs', '_blank')}><ArrowRightIcon style={{color: 'dodgerblue'}}/>MarketLab Docs</h3>
                <h3 style={{display: 'flex', alignItems: 'center', gap: '5px'}} onClick={()=> window.open('https://improwth.com/blog', '_blank')}><ArrowRightIcon style={{color: 'dodgerblue'}}/>Improwth Blog</h3>
            </div>
        </Res>

        <Footer sWidth={sWidth}/>
        
        </Container>
        : <MContainer>
            <MHeader>
                <div>
                    <img src={logo} alt='logo' />
                </div>
                <div>
                    <SegmentIcon onClick={()=> setShowNav(prev=> !prev)}/>
                    {showNav && <div ref={showNavRef} style={{zIndex: '1000', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)'}}>
                        <p onClick={()=> window.open('https://improwth.com/products/market-lab/docs', '_blank')}>Docs</p>
                        <p onClick={()=> window.location.href = '#features'}>Features</p>
                        <p onClick={()=> window.location.href = '#pricing'}>Pricing</p>
                        <p onClick={()=> window.location.href = '/login'}>Sign In</p>
                        <p onClick={()=> window.location.href = '/register'}>Create Account</p>
                    </div>}
                </div>
            </MHeader>

            <MHero>
                <img src={mhero} />
                 <h1>All-in-One Platform for <span>Superior SEO Insights</span> and Competitive Edge</h1>
                 {/* <p>Discover MarketLab, the ultimate suite of integrated tools designed to elevate your SEO and digital marketing efforts</p> */}
                <div style={{alignItems: 'center'}}>
                    <button style={{width: '90%', marginLeft: '5px'}} onClick={()=> window.location.href = '/register'}>Try Now For Free - No credit card required</button>
                    {/* <button onClick={()=> window.location.href = '#features'}>Learn More</button> */}
                </div>
            </MHero>

            <MInApp id='features'>
            <div className='title'>
                <h2>Discover What’s Inside <span>MarketLab</span></h2>
                <p>Unlock the full potential of your digital marketing strategy with MarketLab's suite of innovative tools</p>
            </div>

            <div className='tools'>
                    <div>
                        <h3>Keyword Research Mastery</h3>
                        <p>Uncover high-impact keywords and tailor your content to target audiences effectively</p>
                        <p className='points'><CheckCircleIcon /> Identify High-Impact Keywords</p>
                        <p className='points'><CheckCircleIcon /> Optimize Content Strategy</p>
                        <p className='points'><CheckCircleIcon /> Discover Niche Opportunities</p>
                    </div>
                </div>


            <div className='tools'>
                    <div>
                        <h3>Link Power Unleashed</h3>
                        <p>Uncover and leverage your website’s backlinks to boost authority and visibility</p>
                        <p className='points'><CheckCircleIcon /> Evaluate Link Quality</p>
                        <p className='points'><CheckCircleIcon /> Identify Toxic Links</p>
                        <p className='points'><CheckCircleIcon /> Monitor Link Growth</p>
                    </div>
                </div>

                <div className='tools'>
                    <div>
                        <h3>Comprehensive Site Testing</h3>
                        <p>Ensure peak performance with extensive tests for speed, functionality, and user experience to keep your site running smoothly and efficiently</p>
                        <p className='points'><CheckCircleIcon /> Page Speed Test</p>
                        <p className='points'><CheckCircleIcon /> Mobile Responsiveness Test</p>
                        <p className='points'><CheckCircleIcon /> Crawlability Test</p>
                    </div>
                </div>


                <div className='tools'>
                    <div>
                        <h3>On-Page Optimization Tools</h3>
                        <p>Enhance your website’s on-page SEO to improve rankings and user experience with precise optimizations.</p>
                        <p className='points'><CheckCircleIcon /> Optimize Meta Tags and Descriptions</p>
                        <p className='points'><CheckCircleIcon /> Analyze and Adjust Keyword Density</p>
                        <p className='points'><CheckCircleIcon /> Conduct Comprehensive Link Analysis</p>
                    </div>
                </div>

                <div className='title'>
                    <h2>... and more!</h2>
                </div>
        </MInApp>


        <MMLUpdates>
            <h2>Introducing MarketLab Version 5: The Next Evolution in SEO & Digital Marketing Tools</h2>

            <video controls width="320px">
            <source src='https://firebasestorage.googleapis.com/v0/b/market-lab-2ed93.appspot.com/o/media%2Fml_v5.mp4?alt=media&token=aa7e66d2-6485-47ba-bc26-013553e2b090' type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </MMLUpdates>

        <div style={{marginTop: '300px'}} id='pricing'>
        <h2 style={{color: 'white', width: '95%', textAlign: 'center', fontSize: '40px', marginBlock: '20px'}}>Find a plan that's right for you</h2>
        <p style={{fontFamily: 'Quicksand', margin: '10px', color: 'lightgrey', width: '90%', textAlign: 'left', marginBottom: '30px'}}>Choose the perfect plan tailored to your needs and usage preferences</p>
        <MPricing>
            <MCard>
                <h3>Forever Free</h3>
                <h4><span className='sign'>$</span><span className='price'>0</span>/month</h4>
                <p>Get 60 credits per month at no cost to explore MarketLab’s essential tools and features</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>

                <p><CheckIcon /> 60 Credits Per Month</p>
                <p><CheckIcon /> No Cost</p>
                <p><CheckIcon /> Ideal for Small Projects</p>
                <p><CheckIcon /> Experience Core Features</p>
                <p><CheckIcon /> Risk-Free Trial</p>
                <p><CheckIcon /> No credit card required</p>
            </MCard>

            <MCard style={{backgroundColor: 'rgb(32, 41, 56)', marginLeft: '40px'}}>
                <h3>Premium</h3>
                <h4><span className='sign'>$</span><span className='price'>20</span>/month</h4>
                <p>Unlock unlimited access, advanced features, and priority support for optimal performance and insights</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>
                <p><CheckIcon /> Unlimited Access</p>
                <p><CheckIcon /> Advanced Insights</p>
                <p><CheckIcon /> Priority Support</p>
                <p><CheckIcon /> Unlimited Projects</p>
                <p><CheckIcon /> Exclusive Features</p>
                <p><CheckIcon /> Fresh Data</p>
            </MCard>

            <MCard>
                <h3>Occasional Users</h3>
                <p>Buy credits in any amount you need, allowing for flexible, on-demand access to MarketLab features. Ideal for occasional users who want to manage their spending and only pay for what they use</p>

                <div style={{marginTop: '30px'}} />
                <button onClick={()=> window.location.href = '/register'}>Start Now</button>

                <p><CheckIcon /> Flexible Credit Purchase</p>
                <p><CheckIcon /> Customizable Plans</p>
                <p><CheckIcon /> Immediate Usage</p>
                <p><CheckIcon /> On-Demand Support</p>
                <p><CheckIcon /> No Subscription Required</p>
                <p><CheckIcon /> Scalable Access</p>
            </MCard>
        </MPricing>
        </div>

        <FAQ />


        <Res style={{backgroundColor: 'black', width: '100%', paddingBlock: '60px'}}>
            <h2 style={{fontSize: '27px', margin: '10px'}}>Resources to help you get the most out of <span style={{fontFamily: 'Crimson Text', fontWeight: '300'}}>MarketLab</span></h2>

            <div style={{display: 'flex', flexDirection: 'column', width: '95%', alignItems: 'start', gap: '10px'}}>
                <h3 style={{display: 'flex', alignItems: 'center', gap: '5px'}} onClick={()=> window.open('https://improwth.com/products/market-lab/docs', '_blank')}><ArrowRightIcon style={{color: 'dodgerblue'}}/> MarketLab Docs</h3>
                <h3 style={{display: 'flex', alignItems: 'center', gap: '5px'}} onClick={()=> window.open('https://improwth.com/blog', '_blank')}><ArrowRightIcon style={{color: 'dodgerblue'}}/>Improwth Blog</h3>
            </div>
        </Res>

        <Footer sWidth={sWidth}/>
        </MContainer>}
    </>}
    </>
  )
}

export default Root


const Container = styled.div`
    /* display: grid;
    grid-template-rows: auto 1fr auto; */
    /* display: flex;
    flex-direction: column; */
    height: 100vh;
    overflow-y: auto;
    width: 100vw;
    z-index: 1000;
    background-color: rgb(20, 27, 43);
    overflow-x: hidden;
    scroll-behavior: smooth;
`

const gradientAnimation1 = keyframes`
  0% {
    background: radial-gradient(circle, #f06, transparent 30%);
  }
  50% {
    background: radial-gradient(circle, #4a90e2, transparent 32%);
  }
  100% {
    background: radial-gradient(circle, #f06, transparent 30%);
  }
`;

const gradientAnimation2 = keyframes`
  0% {
    background: radial-gradient(circle, #4a90e2, transparent 30%);
  }
  50% {
    background: radial-gradient(circle, #f06, transparent 32%);
  }
  100% {
    background: radial-gradient(circle, #4a90e2, transparent 30%);
  }
`;



const Header = styled.div`
    display: flex;
    padding: 15px;
    align-items: center;
    gap: 25px;

    > div {
        display: flex;
        align-items: center;
        gap: 10px;

        > img {
            object-fit: contain;
            width: 200px;
            z-index: 5;
            /* filter: brightness(0%); */
        }

        > p {
            color: white;
            transition: color 0.3s ease-in-out;
            cursor: pointer;
            margin-right: 25px;
            font-family: 'Quicksand';

            &:hover {
                color: lightgray;
            }
        }
    }

    > div  >.light {
        border-radius: 50%;
        width: 360px;
        height: 360px;
        /* background: radial-gradient(circle, #f06, transparent 30%); */
        /* animation: ${gradientAnimation1} 8s infinite ease-in-out;  */
        position: absolute;
        right: -120px;
        z-index: 3;
    }
    > div  >.light_0 {
        border-radius: 50%;
        width: 460px;
        height: 460px;
        /* background: radial-gradient(circle, #4a90e2, transparent 32%); */
        /* animation: ${gradientAnimation2} 8s infinite ease-in-out;  */
        position: absolute;
        right: -90px;
        z-index: 3;
    }
`

const rayAnimation = keyframes`
    0% {
        opacity: 0.5;
    }

    50% {
        opacity: 0;
    }

    75% {
        opacity: 0.5;
    }

    100% {
        opacity: 0;
    }
`



const Ray = styled.div`
    position: absolute;
    width: ${props=> props.w}px;
    height: ${props=> props.h}px;
    left: 20%;
    transform: rotate(${props => props.tr}deg) translateY(100px) translateX(-50px);
    background: linear-gradient(90deg, ${props=> props.c}, transparent);

    opacity: 0;
    animation: ${rayAnimation} ${props=> props.d}s ease-in-out alternate infinite;

    z-index: 2;
`

const fade = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`


const Hero = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 100px;
    padding-block: 150px;

    > div {
        display: flex;
        flex-direction: column;
        padding: 60px;

        > h1 {
            color: white;
            font-size: 50px;

            > span {
                font-size: 48px;
                font-weight: bold;
                background: linear-gradient(45deg, #f06, #4a90e2);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                /* text-fill-color: transparent; */
            }
        }

        > p {
            color: lightgray;
            margin-top: 20px;
            font-family: 'Quicksand';
        }

        > div {
            display: flex;
            align-items: center;
            gap: 50px;
            margin-top: 20px;

            > button {
                border: none;
                border-radius: 2px;
                padding: 10px 15px;
                cursor: pointer;
                background-color: #4a90e2;
                transition: background-color 0.3s ease-in-out;
                color: white;
                font-weight: 400;
                font-family: 'Quicksand';
                
                &:hover {
                    background-color: transparent;
                    color: white;
                }
            }
        }

        > img {
            object-fit: contain;
            width: 860px;
            position: absolute;
            top: -200px;
            left: -120px;
            
            opacity: 0;
            animation: ${fade} 0.4s ease-in-out forwards;
        }
    }
`


const InApp = styled.div`
    display: flex;
    flex-direction: column;
    gap: 80px;
    min-height: 500px;
    

    > .title {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;

        > h2 {
            color: white;
            font-size: 50px;

            > span {
                font-size: 48px;
                font-weight: bold;
                background: linear-gradient(45deg, #f06, #4a90e2);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                font-family: 'Crimson Text';
                font-weight: 300;
            }
        }
        > p {
            font-family: 'Quicksand';
            color: white;
        }
    }

    > .tools {
        display: flex;
        align-items: center;
        gap: 0px;

        > div {
            display: flex;
            flex-direction: column;
            gap: 30px;
            padding: 30px;

            > h3 {
                color: white;
                font-size: 25px;
                color: white;
            }

            > p {
                font-family: 'Quicksand';
                color: white;
            }

            > img {
                object-fit: contain;
                width: 830px;
                border-radius: 3px;
            }

            > .points {
                display: flex;
                align-items: center;
                gap: 6px;
                color: lightgray;

                > .MuiSvgIcon-root {
                    color: #0bad0b;
                    font-size: medium;
                }
            }
        }
    }
`


const MLUpdates = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 500px;
    gap: 60px;
    align-items: center;
    justify-content: center;
    margin-top: 200px;
    background-color: black;
    padding-block: 80px;

    > h2 {
        font-size: 40px;
        color: white;
        width: 90%;
    }

    > p {
        width: 90%;
        font-family: 'Quicksand';
        color: white;
    }

    > video {
        width: 700px;
        border-radius: 5px;
    }
`


const Pricing = styled.div`
    display: flex;
    gap: 30px;
    width: 95%;
    justify-content: center;
    align-items: center;
    margin-bottom: 300px; /* Adjust this value as needed */
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 500px; /* Adjust the size of the circle */
        height: 500px; /* Adjust the size of the circle */
        background: dodgerblue; /* Light color for the blur */
        border-radius: 50%;
        filter: blur(50px); /* Adjust the blur radius */
        transform: translate(-50%, -50%);
        z-index: 5;
        animation: moveBlur 5s infinite alternate; /* Animation for the moving effect */
    }

    @keyframes moveBlur {
        0% {
            transform: translate(-50%, -50%) translateX(-30px) translateY(-30px);
        }
        100% {
            transform: translate(-50%, -50%) translateX(30px) translateY(30px);
        }
    }
`;






const Card = styled.div`
    padding: 25px 20px;
    border-radius: 4px;
    color: white;
    width: 360px;
    z-index: 6;

    
    > p {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        font-family: 'Quicksand';
        margin-top: 10px;
        color: lightgray;

        > .MuiSvgIcon-root {
            color: #18a618;
            font-size: medium;
        }
    }

    > h3 {
        font-size: 20px;
        font-weight: 400;
    }

    > h4 {
        color: lightgray;
        font-family: 'Quicksand';
        margin-block: 5px;

        > .sign {
            font-size: 25px;
        }

        > .price {
            font-size: 30px;
            color: white;
        }
    }

    > button {
        font-family: 'Quicksand';
        padding: 10px 20px;
        border-radius: 3px;
        cursor: pointer;
        color: white;
        transition: background-color 0.3s ease-in-out;
        background-color: dodgerblue;
        border: none;
        margin-bottom: 30px;


        &:hover {
            background-color: transparent;
        }
    }
`


const Res = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    justify-content: center;
    align-items: center;
    width: 95%;
    color: white;
    margin-bottom: 160px;

    > h2 {
        font-size: 50px;
    }

    > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 50%;
        margin-top: 50px;

        > h3 {
            font-family: 'Quicksand';
            font-weight: 300;
            cursor: pointer;
            transition: color 0.3s ease-in-out;
            
            &:hover {
                color: dodgerblue;
            }
        }
    }
`

const slideFromAbove = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;



const MContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: rgb(20, 27, 43);
    scroll-behavior: smooth;
    width: 100vw;
    height: 100vh !important;
    overflow-x: hidden;
    overflow-y: auto !important;
`


const MHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 10px;
    justify-content: space-between;
    height: auto;
    margin-bottom: 20px;

    > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        > img {
            object-fit: contain;
            width: 200px;
            filter: grayscale(200%) invert(1) brightness(2);
        }

        > .MuiSvgIcon-root {
            color: white;
            position: relative;
            margin-top: 5px;
        }

        > div {
            position: absolute;
            color: black;
            background-color: white;
            width: 200px;
            height: fit-content;
            padding: 10px;
            border-radius: 3px;
            top: 60px;
            right: 20px;

            animation: ${slideFromAbove} 0.3s ease-out forwards;

            > p {
                font-family: 'Quicksand';
                margin-block: 10px;
            }
        }
    }
`

const MHero = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin-top: 20px;
    justify-content: end;
    width: 100%;
    min-height: 500px;

    
    > img {
        object-fit: contain;
        width: 95%;
        border-radius: 5px;
        margin-bottom: auto;

        -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
        mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
    }


    > h1 {
        color: white;
        font-size: 29px;

        > span {
                font-size: 29px;
                font-weight: bold;
                background: linear-gradient(45deg, #f06, #4a90e2);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
        }
    }

    > p {
            color: lightgray;
            margin-top: 20px;
            font-family: 'Quicksand';
            width: 95%;
        }

        > div {
            display: flex;
            align-items: center;
            gap: 50px;
            margin-top: 20px;
        

            > button {
                border: none;
                border-radius: 2px;
                padding: 10px 15px;
                cursor: pointer;
                background-color: #4a90e2;
                transition: background-color 0.3s ease-in-out;
                color: white;
                font-weight: 400;
                font-family: 'Quicksand';
                
                &:hover {
                    background-color: transparent;
                    color: white;
                }
            }
        }
`


const MInApp = styled.div`
    display: flex;
    flex-direction: column;
    gap: 80px;
    height: auto;
    margin-top: 160px;
    padding-bottom: 50px;
    

    > .title {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-bottom: 10px;

        > h2 {
            color: white;
            font-size: 50px;
            margin: 10px;

            > span {
                font-size: 48px;
                font-weight: bold;
                background: linear-gradient(45deg, #f06, #4a90e2);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                font-family: 'Crimson Text';
                font-weight: 300;
            }
        }
        > p {
            font-family: 'Quicksand';
            color: white;
            margin: 0px 10px 0px 10px;
        }
    }

    > .tools {
        display: flex;
        align-items: center;
        gap: 0px;
        margin: 0px;

        > div {
            display: flex;
            flex-direction: column;
            gap: 30px;
            padding: 30px;

            > h3 {
                color: white;
                font-size: 25px;
                color: white;
            }

            > p {
                font-family: 'Quicksand';
                color: white;
            }

            > img {
                object-fit: contain;
                width: 830px;
                border-radius: 3px;
            }

            > .points {
                display: flex;
                align-items: center;
                gap: 6px;
                color: lightgray;

                > .MuiSvgIcon-root {
                    color: #0bad0b;
                    font-size: medium;
                }
            }
        }
    }
`


const MMLUpdates = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 500px;
    gap: 60px;
    align-items: center;
    justify-content: center;
    margin-bottom: -80px;
    margin-top: 100px;
    background-color: black;

    > h2 {
        font-size: 30px;
        color: white;
        width: 90%;
    }

    > p {
        width: 90%;
        font-family: 'Quicksand';
        color: white;
        font-size: 25px;
    }

    > video {
        width: 90%;
        border-radius: 5px;
    }
`


const MPricing = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 95%;
    justify-content: center;
    align-items: center;
    margin-bottom: 100px; /* Adjust this value as needed */
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 500px; /* Adjust the size of the circle */
        height: 500px; /* Adjust the size of the circle */
        background: dodgerblue; /* Light color for the blur */
        border-radius: 50%;
        filter: blur(50px); /* Adjust the blur radius */
        transform: translate(-50%, -50%);
        z-index: 5;
        animation: moveBlur 5s infinite alternate; /* Animation for the moving effect */
    }

    @keyframes moveBlur {
        0% {
            transform: translate(-50%, -50%) translateX(-30px) translateY(-30px);
        }
        100% {
            transform: translate(-50%, -50%) translateX(30px) translateY(30px);
        }
    }
`;


const MCard = styled.div`
    padding: 25px 20px;
    border-radius: 4px;
    color: white;
    width: 90% !important;
    z-index: 6;
    margin: 15px 20px 0 20px;
    display: flex;
    flex-direction: column;

    
    > p {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        font-family: 'Quicksand';
        margin-top: 10px;
        color: lightgray;

        > .MuiSvgIcon-root {
            color: #18a618;
            font-size: medium;
        }
    }

    > h3 {
        font-size: 20px;
        font-weight: 400;
    }

    > h4 {
        color: lightgray;
        font-family: 'Quicksand';
        margin-block: 5px;

        > .sign {
            font-size: 25px;
        }

        > .price {
            font-size: 30px;
            color: white;
        }
    }

    > button {
        font-family: 'Quicksand';
        padding: 10px 20px;
        border-radius: 3px;
        cursor: pointer;
        color: white;
        transition: background-color 0.3s ease-in-out;
        background-color: dodgerblue;
        border: none;
        margin-bottom: 30px;


        &:hover {
            background-color: transparent;
        }
    }
`